<template>
  <div class="preview-fallback">
    <MDBIcon :icon="iconName" class="preview-fallback__icon" />
    <span class="preview-fallback__badge">{{ displayExtension }}</span>
    <span class="preview-fallback__text">{{ fileName }}</span>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { MDBIcon } from "mdb-vue-ui-kit";

const props = defineProps({
  extension: {
    type: String,
    default: "",
  },
  fileName: {
    type: String,
    default: "File preview",
  },
});

const normalizedExtension = computed(() =>
  String(props.extension || "file").replace(".", "").toLowerCase(),
);

const displayExtension = computed(() => normalizedExtension.value.toUpperCase());

const iconName = computed(() => {
  if (["doc", "docx"].includes(normalizedExtension.value)) {
    return "file-word";
  }

  if (["xls", "xlsx", "csv"].includes(normalizedExtension.value)) {
    return "file-excel";
  }

  if (["ppt", "pptx"].includes(normalizedExtension.value)) {
    return "file-powerpoint";
  }

  if (normalizedExtension.value === "pdf") {
    return "file-pdf";
  }

  return "file";
});
</script>

<style scoped lang="scss">
@import "@/styles/document-preview/preview-fallback";
</style>
